import { render, staticRenderFns } from "./UpdateBuildingLog.vue?vue&type=template&id=d55e060c&lang=pug&"
import script from "./UpdateBuildingLog.vue?vue&type=script&lang=ts&"
export * from "./UpdateBuildingLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports